import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Alert from './Alert';

interface ClosableFormHeaderProps {
  onClose: () => void;
  isModified: boolean;
  isSubmitting?: boolean;
  title?: string;
}

export default function CloseButton({
  onClose,
  isModified,
  isSubmitting = false,
  title = 'You have unsaved changes',
}: ClosableFormHeaderProps) {
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const handleClose = () => {
    if (isModified) {
      setShowConfirmation(true);
    } else {
      onClose();
    }
  };

  const handleConfirmClose = () => {
    setShowConfirmation(false);
    onClose();
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleClose}
        disabled={isSubmitting}
        className="h-8 w-8 p-0 hover:bg-destructive hover:text-destructive-foreground"
        aria-label="Close form"
        data-testid="close-button"
      >
        <X size={16} />
      </Button>

      <Alert
        open={showConfirmation}
        setOpen={setShowConfirmation}
        title={title}
        description="Are you sure you want to close? Your changes will not be saved."
        action={handleConfirmClose}
      />
    </>
  );
}
